import React, { FC, useCallback } from 'react';
import { Grid } from '@material-ui/core';
import CurrencySwitch from '../../../../../../common/components/currencySwitch/CurrencySwitch';
import locale from '../../../../../../common/service/locale';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import { usePersistedCurrencyPreference } from '../../../../../react/usePersistedCurrencyPreference';
import { IPrice } from '../../../../../../../../common/model/IPrice';

const CurrencySwitchContainer: FC = () => {
  const isMultiCurrency: boolean = useSelector(currentDealSelectors.getIsMultiCurrency);
  const { isSecondaryCurrencyDisplay, setIsSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();
  const primaryPrice: IPrice = useSelector(currentDealSelectors.getPrimaryPrice);
  const secondaryPrice: IPrice = useSelector(currentDealSelectors.getSecondaryPrice);

  const handleCurrencyChange = useCallback(() => {
    setIsSecondaryCurrencyDisplay(!isSecondaryCurrencyDisplay);
  }, [isSecondaryCurrencyDisplay]);

  return (
    <Grid item={true}>
      {isMultiCurrency && secondaryPrice && (
        <CurrencySwitch
          name="currency-switch"
          data-test="summary:currency-toggle"
          disableRipple={false}
          labelBefore={locale.getCurrencyLocaleCodeForLabel(primaryPrice?.currency)}
          labelAfter={locale.getCurrencyLocaleCodeForLabel(secondaryPrice?.currency)}
          checked={isSecondaryCurrencyDisplay}
          onChange={handleCurrencyChange}
        />
      )}
    </Grid>
  );
};

export default CurrencySwitchContainer;
